<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de aplicação">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/imunizacao/relatorio-de-aplicacao/List'

export default {
    components: { List },
}
</script>